const unexpectedErrorMessageBase =
  "An unexpected error occurred. Please try again later, or contact support if the problem persists.";

/**
 * If the error has a code, use the codeToMessage map to try and get the friendly message.
 * Otherwise, construct a friendly message from the error message and possibly the code.
 **/
export function friendlyErrorMessage(
  error: Error | unknown,
  codeToFriendlyMessage?: Record<string, string>,
): string {
  if (!(error instanceof Error)) {
    return unexpectedErrorMessageBase;
  }

  if (
    "code" in error &&
    typeof error.code === "string" &&
    codeToFriendlyMessage &&
    error.code in codeToFriendlyMessage
  ) {
    return codeToFriendlyMessage[
      error.code as keyof typeof codeToFriendlyMessage
    ];
  }

  const errorMessageText = error.message
    ? ` Error message: ${error.message}.`
    : "";

  const errorCode =
    "code" in error && typeof error.code === "string"
      ? ` Error code: ${error.code}.`
      : "";

  return unexpectedErrorMessageBase + errorMessageText + errorCode;
}
